import PropTypes from "prop-types"

import React, { Component } from "react"
import { browserHistory } from "react-router"
import classNames from "classnames"
import Popover from "react-bootstrap/lib/Popover"
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger"
import BadgeLink from "../elements/BadgeLink"
import { FormattedMessage, injectIntl, FormattedHTMLMessage } from "react-intl"
import tagMessages from "../../messages/tags"
import { getStyleTag, getStyles } from "../../styles/dynamicStyles"
import { isomorphicVars } from "../../scripts/isomorphicVars"
import { getAccountSettings } from "../../scripts/accountSettings"

class TagList extends Component {
  static propTypes = {
    title: PropTypes.string,
    extraClasses: PropTypes.string,
    handleTagClick: PropTypes.func,
    userAddable: PropTypes.bool
  }

  constructor(props) {
    super(props)

    this.state = {
      expanded: false,
      saving: false
    }

    const { authentic_account_id: authenticAccountId } = isomorphicVars()
    const {
      settings: { community_taggings_enabled: communityTaggingsEnabled }
    } = getAccountSettings(authenticAccountId)
    this._community_taggings_enabled = communityTaggingsEnabled
  }

  _handleOpenTagAdder = e => {
    e.preventDefault()
    //wait for popover to init
    setTimeout(() => {
      this.setState(
        {
          expanded: true
        },
        () => {
          this.refs.newTagInput.focus()
        }
      )
    }, 50)
  }

  _handleAddTag = e => {
    e.preventDefault()

    const tag = this.refs.newTagInput.value
    const uuid = this.props.resourceId

    if (this.props.handleAddTag) {
      this.setState({
        saving: true
      })

      this.props
        .handleAddTag(tag, uuid)
        .then(() => {
          this.setState({
            saving: false
          })
          this._handleCancelTagAdder()
        })
        .catch(err => {
          this.setState({ saving: false })
          this._handleCancelTagAdder()
        })
    }
  }

  _handleCancelTagAdder = () => {
    this.refs.newTagInput.blur()
    this.refs.popover.hide()

    this.setState({
      expanded: false
    })
  }

  _handleTagClick = (tag, e) => {
    if (this.props.handleTagClick) {
      this.props.handleTagClick(tag, e)
    }
  }

  render() {
    const { title, extraClasses, userAddable, intl } = this.props
    const baseClassNames = classNames("taglist", {
      "is-open": this.state.expanded
    })

    const extras = extraClasses ? extraClasses : ""

    const addHandleable = typeof this.props.handleAddTag === "function"

    return (
      <div className={`${baseClassNames} ${extras}`}>
        {getStyleTag([
          "badge",
          "badge-button",
          "badge-a",
          "input-group-button__button"
        ])}
        <dt>{title}</dt>
        <span itemProp="keywords">
          {this.props.tags &&
            this.props.tags.length > 0 &&
            this.props.tags.map((tag, i) => (
              <dd key={i}>
                <BadgeLink onClick={e => this._handleTagClick(tag, e)}>
                  {tag}
                  <span className="hide for-schema-markup-only">, </span>
                </BadgeLink>
              </dd>
            ))}
        </span>
        {addHandleable && !userAddable && this._community_taggings_enabled ? (
          <dd>
            <button
              title={intl.formatMessage(tagMessages.loginToAdd)}
              className="taglist__addbtn badge badge--transparent"
              onClick={e =>
                browserHistory.push(
                  `/login?next=/item/${this.props.resourceId}`
                )
              }
            >
              {` + ${intl.formatMessage(tagMessages.loginToAdd)}`}
            </button>
          </dd>
        ) : null}
        {addHandleable && userAddable && this._community_taggings_enabled ? (
          <OverlayTrigger
            trigger="click"
            rootClose={true}
            placement="top"
            ref="popover"
            overlay={
              <Popover
                title={intl.formatMessage(tagMessages.tagThisItem)}
                id="popover-can-add"
              >
                <div
                  className="taglist__add"
                  aria-expanded={this.state.expanded ? "true" : "false"}
                  aria-hidden={this.state.expanded ? "false" : "true"}
                >
                  <form
                    className={classNames("form--can-load form--onwhite", {
                      "state-form-loading": this.state.saving
                    })}
                  >
                    <div
                      className="input-group"
                      style={getStyles("input-group")}
                    >
                      <input
                        className="input-group-field"
                        type="text"
                        ref="newTagInput"
                        placeholder={intl.formatMessage(
                          tagMessages.enterTagNames
                        )}
                        onKeyDown={e => {
                          e.keyCode === 13 ? this._handleAddTag(e) : null
                        }}
                      />
                      <div className="input-group-button">
                        <button
                          onClick={this._handleAddTag}
                          type="button"
                          className={classNames("button button--can-load", {
                            "state-loading": this.state.saving
                          })}
                          style={getStyles("input-group-button__button")}
                        >
                          <FormattedMessage {...tagMessages.add} />
                        </button>
                      </div>
                    </div>
                    <p className="help-text mbn" style={getStyles("help-text")}>
                      <FormattedHTMLMessage {...tagMessages.addMultiple} />
                    </p>
                  </form>
                </div>
              </Popover>
            }
          >
            <dd>
              <button
                title={intl.formatMessage(tagMessages.addTag)}
                className="taglist__addbtn badge badge--transparent"
                aria-haspopup="true"
                aria-owns="popover-can-add"
                aria-expanded={this.state.expanded ? "true" : "false"}
                onClick={this._handleOpenTagAdder}
              >
                + <FormattedMessage {...tagMessages.add} />
              </button>
            </dd>
          </OverlayTrigger>
        ) : null}
      </div>
    )
  }
}

export default injectIntl(TagList)



// WEBPACK FOOTER //
// ./webapp/components/elements/TagList.js